export default defineNuxtPlugin(() => {
  onNuxtReady(async () => {
    /* eslint-disable */
    window.__lc = window.__lc || {};
    window.__lc.license = 8184711;
    window.__lc.chat_between_groups = false;
    (function (n, t, c) {
      function i(n) {
        return e._h ? e._h.apply(null, n) : e._q.push(n);
      }
      var e = {
        _q: [],
        _h: null,
        _v: "2.0",
        on: function () {
          i(["on", c.call(arguments)]);
        },
        once: function () {
          i(["once", c.call(arguments)]);
        },
        off: function () {
          i(["off", c.call(arguments)]);
        },
        get: function () {
          if (!e._h)
            throw new Error(
              "[LiveChatWidget] You can't use getters before load."
            );
          return i(["get", c.call(arguments)]);
        },
        call: function () {
          i(["call", c.call(arguments)]);
        },
        init: function () {
          var n = t.createElement("script");
          (n.async = !0),
            (n.type = "text/javascript"),
            (n.src = "https://cdn.livechatinc.com/tracking.js"),
            t.head.appendChild(n);
        },
      };
      !n.__lc.asyncInit && e.init(), (n.LiveChatWidget = n.LiveChatWidget || e);
    })(window, document, [].slice);
    /* eslint-enable */

    
    function livechatOnFormSubmitted(data) {
      switch (data.type) {
          case "prechat": {
              // prechat submitted
              const utms = useState('utms').value;

              if (utms) {
                  try {
                      const interests =  utms.interests || [];

                      interests.push("livechat_prechat");

                      utms.interests = interests;

                      // write utms to localstorage
                      localStorage.setItem("_abbuc_", JSON.stringify(utms));

                      // set state
                      useState<Utms>("utms", () => utms);
                  } catch (err) {
                      console.error("failed to add livechat_prechat interest", err);
                  }
              } else {
                  console.log("no utms object");
              };

              break;
          }
          case "postchat":
              // postchat submitted
              break;

          case "ticket":
              // ticket submitted
              break;

          default:
              break;
      }
  };

  if (typeof window.LiveChatWidget !== "undefined") {
    window.LiveChatWidget.on('form_submitted', livechatOnFormSubmitted)
    // LiveChatWidget.off('form_submitted', livechatOnFormSubmitted)
    //console.log(window.LiveChatWidget);
  }

  });
});
